export default "__VITE_ASSET__f16ab1b0__"